import { Injectable } from '@angular/core';
import { ScreenOrientation as CapacitorScreenOrientation } from '@capacitor/screen-orientation';

@Injectable({
  providedIn: 'root',
})
export class ScreenOrientationService {
  lock(orientation: OrientationType): Promise<void> {
    return CapacitorScreenOrientation.lock({ orientation });
  }
}
